import Logo from 'assets/images/logo-med-tekst.png';
import { Box, Image } from 'grommet';
import useResponsive from 'hooks/useResponsive';
import Auth from 'modules/auth/Auth';
import React from 'react';
import { appRouteItems } from '../appRouteItems';
import HeaderItem from './HeaderItem';
import { LinkItem } from './LinkItem';
import MiniMenu from './MiniMenu';

const AppHeader = () => {
  const { isMobile } = useResponsive();

  return (
    <Box
      tag="header"
      direction="row"
      background="rgb(0,17,47)"
      align="center"
      justify="between"
      height="xsmall"
      style={{
        position: 'sticky', top: 0, zIndex: 1, userSelect: 'none'
      }}
    >
      <Box direction="row-responsive" pad="medium">
        <LinkItem route="/">
          <Box
            width="small"
            height="xsmall"
            pad="xsmall"
          >
            <Image fit="contain" src={Logo} />
          </Box>
        </LinkItem>
      </Box>
      {!isMobile && (
        <Box
          margin={{ left: 'medium' }}
          round="xsmall"
          direction="row"
          align="end"
          pad={{ horizontal: 'small' }}
        >
          {appRouteItems.map(({ route, label }) =>
            <HeaderItem key={label} route={route} label={label} />
          )}
          <Box pad="xsmall" style={{ marginLeft: '24px' }}>
            <Auth />
          </Box>
        </Box>
      )}
      {isMobile && <MiniMenu appRouteItems={appRouteItems} />}
    </Box>
  );
};

export default AppHeader;
